module.exports = __webpack_public_path__ + "res/img_bottom.4b5a3e1b1e8726490d89700430270da1.png";